import { FormHeaderCheckbox } from 'components/shared/FormHeaderCheckbox/FormHeaderCheckbox';
import { FormattedMessage } from 'components/shared/Intl/FormattedMessage';
import { FC, useCallback } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import styled from 'styled-components';

import { connectedBatchGridActionHeader } from './GridActionHeader.connect';
import type { BatchGridActionHeaderProps } from './GridActionHeader.model';

const StyledDiv = styled.div`
  grid-column: span 2;
`;

export const BatchGridActionHeaderComponent: FC<BatchGridActionHeaderProps> = ({
  areAllFormsSelected,
  isNoFormSelected,
  onNewFormAdded,
  onSelectAllToggled,
  canAddNewForm,
  className,
}) => {
  const onNewForm = useCallback(() => {
    logAnalytics.trackEvent('Batch Workspace', 'Add an item');
    onNewFormAdded();
  }, [onNewFormAdded]);

  const onSelectAll = useCallback(() => {
    logAnalytics.trackEvent('Batch Workspace', 'Select all items');
    onSelectAllToggled();
  }, [onSelectAllToggled]);

  return (
    <StyledDiv className={className}>
      <div
        className="bg-lvl2 ps-3 d-flex flex-row align-items-center justify-content-between"
        data-e2e="batch-grid-action-header"
      >
        {/* <CustomCheckbox
          e2e="batch-select-all"
          onChange={onSelectAll}
          text={<FormattedMessage id="selectAll" />}
          value={areAllFormsSelected && formIds.length !== 0}
        /> */}

        <FormHeaderCheckbox
          id="batch-select-all"
          e2e="batch-select-all"
          isNoFormSelected={isNoFormSelected}
          areAllFormsSelected={areAllFormsSelected}
          onToggle={onSelectAll}
          hasCustomClass={false}
          text={<FormattedMessage id="selectAll" />}
        />

        <button
          className="btn btn-xl btn-flat-primary"
          data-e2e="batch-add-form"
          onClick={onNewForm}
          disabled={!canAddNewForm}
          type="button"
        >
          <i className="icon">add</i>
        </button>
      </div>
    </StyledDiv>
  );
};

export const BatchGridActionHeader = connectedBatchGridActionHeader(BatchGridActionHeaderComponent);
